const mutations = {
    setSearch(state, val) {
      state.navigation.search = val;
    },
    setOrderField(state, field) {
      state.navigation.orderField = field;
    },
    setOrderMode(state, mode) {
      state.navigation.orderMode = mode;
    },
    setExtraParams(state, payload) {
      state.navigation.extraParams = payload;
    },
    setCustomFilter(state, customFilter) {
      state.navigation.customFilter = customFilter;
    },
    setPage(state, page) {
      state.pagination.page = page;
    },
    setPerPage(state, per_page) {
      state.pagination.per_page = per_page;
    },
    setTotalPages(state, total_pages) {
      state.pagination.total_pages = total_pages;
    },
    setSiteSettings(state, settings) {
      state.siteSettings = {
        ...state.siteSettings,
        ...settings,
      }
    }
};

export default mutations;
